import { render } from "./ThreadMessages.vue?vue&type=template&id=0b4299d9"
import script from "./ThreadMessages.vue?vue&type=script&lang=js"
export * from "./ThreadMessages.vue?vue&type=script&lang=js"

import "./ThreadMessages.vue?vue&type=style&index=0&id=0b4299d9&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__